import { render } from "./Blank.vue?vue&type=template&id=6e3d1ca8&scoped=true"
const script = {}

import "./Blank.vue?vue&type=style&index=0&id=6e3d1ca8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3d1ca8"]])

export default __exports__